'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AutoBind = require('../utils/AutoBind');

var _AutoBind2 = _interopRequireDefault(_AutoBind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ValidationPreparedDelegate(validatorResponder, truncatedState, fullState, navigator, validationNamespace) {
    this._validatorResponder = validatorResponder;
    this._truncatedState = truncatedState;
    this._fullState = fullState;
    this._navigator = navigator;
    this._validationNamespace = validationNamespace;
    (0, _AutoBind2.default)(this, this);
}

// PUBLIC API
//  weak
ValidationPreparedDelegate.prototype = {
    call: function call() {
        this._validationNamespace.notifyValidationPrepared(this._validatorResponder, this._truncatedState, this._fullState);
        this._validatorResponder = null;
        this._truncatedState = null;
        this._fullState = null;
        this._navigator = null;
        this._validationNamespace = null;
    }
};

exports.default = ValidationPreparedDelegate;
//# sourceMappingURL=ValidationPreparedDelegate.js.map